<template>
  <div style="width: 100%; height: 100%;">
    <div style="width: 100%; height: 50px; text-align: center; font-weight: bold; font-size: 20px; line-height: 50px;">
      회사정보
    </div>
    <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto; ">
      <div class="container" style="padding-bottom: 50px;">
        <div class="row" v-for="setting in settings" style="margin-bottom: 10px;">
          <div class="col-12 col-md-2">
            {{setting.description}}
          </div>
          <div class="col-12 col-md-8">
            <input v-if="setting.valueType === 'text'" v-model="setting.text" class="form-control"/>
            <textarea v-else-if="setting.valueType === 'textarea'" v-model="setting.text" class="form-control" rows="10" :ref="'setting-' + setting.type +'-' + setting.field"/>
            <input v-else-if="setting.valueType === 'number'" v-model="setting.value" class="form-control" type="number"/>
            <div v-else-if="setting.valueType === 'image'">
              <img v-if="setting.text !== null && setting.text.length > 0" style="width: 100%; max-width: 200px; border: 1px solid black;" :src="setting.text"/>
              <progress value="0" max="100" :id="'uploader-' + setting.type + '-' + setting.field"></progress>
              <input accept="image/*" type="file" ref="file" value="upload" @change="imageSelected($event, setting)" data-buttonText="사진 선택">
            </div>
          </div>
          <div class="col-12 col-md-2">
            <button class="btn btn-success" @click="updateSetting(setting)">SAVE</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {getDefaultSettings, getSettings, updateSetting, updateSettings} from "../api/settings";
  import {showDialog} from "../api/utils";
  import firebase from "firebase";
  import moment from 'moment';
  export default {
    name: "CompanySetting",
    data() {
      return {
        settings:getDefaultSettings(),
      }
    },
    created() {
    },
    mounted() {
      this.initialise();
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    methods: {
      initialise: function() {
        let self = this;
        getSettings('setting')
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < data.item.length ; i++) {
              for(let j = self.$data.settings.length-1 ; j >= 0 ; j--) {
                if(self.$data.settings[j].type === data.item[i].type &&
                  self.$data.settings[j].field === data.item[i].field) {
                  self.$data.settings.splice(j, 1, data.item[i]);
                  break;
                }
              }
            }
          } else {

          }
        })
        .catch(function(err) {

        })
      },
      updateSetting: function(item) {
        let self = this;
        updateSetting(item)
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < self.$data.settings.length ; i++) {
              if(self.$data.settings[i].type === data.item.type && self.$data.settings[i].field === data.item.field) {
                self.$data.settings.splice(i, 1, data.item);
              }
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {

        })
      },
      imageSelected: function(e, setting) {
        const uploader = document.getElementById('uploader-' + setting.type + '-' + setting.field);
        //get file
        console.log("File Btn Added");
        console.log(e);
        let getFile = e.target.files[0];
        console.log("File name - " + getFile.name);
        //set storage ref
        let d = new Date();
        let name  =  moment(d).format('YYYYMMDD-hhmmss');
        let names = getFile.name.split('.');

        let path = 'settings/' + setting.type + '-' + setting.field + "/"  + name + '.' + names[names.length-1];
        let storageRef = firebase.storage().ref();
        let mountainsRef = storageRef.child(path);
        let self = this;
        mountainsRef.put(getFile).on('state_changed',
          function progress(snapshot){

            let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
            console.log("percentage " + percentage);
            uploader.value = percentage;
          },
          function error(err){
            console.log(err);
          },
          function complete(){
            console.log('complete upload');
            setting.text = 'https://storage.googleapis.com/uko-projects.appspot.com/' + path;
            // self.updateEditGoodItem();
          }
        );
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CompanySetting.vue